import ModalContainer from './ModalContainer';
export default ModalContainer;
//# sourceMappingURL=index.js.map
